import Swiper, {Navigation} from 'swiper/bundle'; // import Swiper bundle with all modules installed

jQuery(document).ready(function ($) {
	"use strict";

    //partner slider
	$('.m-icons__swiper').each(function(){
        let slider = new Swiper($(this).find('.swiper')[0], {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16,
            navigation: {
                nextEl: $(this).find('.swiper-button-next')[0],
                prevEl: $(this).find('.swiper-button-prev')[0],
            },
        });
	});
})